export const getLoanAmount = (price, downPayment) => {
  const loanAmount =  Number(price) - Number(downPayment);
  return loanAmount.toFixed(0);
}
